<template>
  <Table :columns="columns" :data="data"></Table>
</template>
<script>
  import columns from '@/utils/columns';
  import api from '@/api';

  export default {
    props: {
      id: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        data: [],
        columns: [
          columns.ApproveUser(this.$i18n.t('columns.approveUsersNames')),
          columns.ApproveStateName(this.$i18n.t('columns.approveState')),
          columns.ApproveTime(this.$i18n.t('columns.approveTime'), 'auto'),
          {
            title: this.$i18n.t('key20'),
            key: 'ApproveReason',
            render: (h, params) => {
              return h(
                'div',
                // params.row.ApproveState为空时代表待审批的单子，此时审批结果为空
                params.row.ApproveState ? (params.row.ApproveState === -1 ? this.$i18n.t('btn.no') : this.$i18n.t('btn.yes')) : ''
              );
            },
          },
          {
            title: this.$i18n.t('form.approvalIdea'),
            key: 'ApproveReason',
            render: (h, params) => {
              // params.row.ApproveState为0时代表待审批的单子，此时审批意见为空
              // 否则，代表已审批的单子，此时审批意见若为空，则显示“已通过”（兼容老数据，老数据审批通过时，不需要输入审批意见）
              return h('div', params.row.ApproveState === 0 ? '' : params.row.ApproveReason || this.$i18n.t('tab.approved'));
            },
          },
        ],
      };
    },
    watch: {
      async id() {
        const id = this.id;
        if (id) {
          const resp = await api.cims.getPurchase(id);
          if (resp.code == process.env.VUE_APP_code) {
            this.data = resp.response.ApprovalHistory;
          } else {
            this.$Message.error(resp.message);
          }
        }
      },
    },
  };
</script>
